// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__EBPPQ","layout_full":"Layout_layout_full__uz7Wh","header":"Layout_header__05R8D","breadcrumb":"Layout_breadcrumb__vBMH5"};